import { Number } from '@common/Number/Number'

import type { TElemRect } from '../definitions'

/**
 * Elem pozíciójának elkérése.
 * @param rect     - Elem rect.
 * @param toCenter - Az elem közepe.
 */
export default function getLeftTop (rect: TElemRect, toCenter: boolean): [ x: number, y: number ] {
  const x = rect.left + (toCenter ? Number.half(rect.width) : 0)
  const y = rect.top + (toCenter ? Number.half(rect.height) : 0)

  return [ x, y ]
}
